import { render, staticRenderFns } from "./ButtonFilled.vue?vue&type=template&id=3fa14b27&"
import script from "./ButtonFilled.vue?vue&type=script&lang=js&"
export * from "./ButtonFilled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports